<template>
  <sf-modal v-if="showModal" size="xs" @close="closeModal">
    <template #title>
      {{ titleLabel }}
    </template>
    <template #body>
      {{ explanationLabel }}
    </template>

    <template #messages-bottom>
      <sf-modal-message variant="neutral">
        <span
          v-dompurify-html="
            I18n.t(
              'assistant_check.platform.change_account_detail_template.confirm_modal.action',
              {
                from: currentTemplateName,
                to: suggestedTemplateName,
              }
            )
          "
          class="center"
        ></span>
        <i
          v-if="partnerTemplateDescription"
          v-tooltip="partnerTemplateDescription"
          class="icon icon-info-circle tw-text-sf-gray-light"
        />
      </sf-modal-message>
    </template>

    <template #footer>
      <a
        class="sf-btn"
        data-heap="assistant-action-cancel-change-account-detail-template"
        @click="closeModal"
      >
        {{ btnCancelLabel }}
      </a>
      <a
        class="sf-btn sf-btn-success"
        :data-heap="actionHeapAnalyticId"
        @click="confirm"
      >
        {{ btnConfirmLabel }}
      </a>
    </template>
  </sf-modal>
</template>

<script lang="ts" setup>
import I18n from 'i18n-js'
import { ref } from 'vue'
import { SfModal, SfModalMessage } from '@app/shared/vue/components/sf-modal'
import {
  CheckAction,
  ChangeAccountDetailTemplateParameters,
} from '@app/shared/types/sf-data'

const showModal = ref(true)

let onConfirm: () => void
const currentTemplateName = ref('')
const suggestedTemplateName = ref('')
const partnerTemplateDescription = ref<string | null>('')
const actionHeapAnalyticId = ref('')

const titleLabel = window.I18n.t(
  'assistant_check.platform.change_account_detail_template.confirm_modal.title'
)

const explanationLabel = window.I18n.t(
  'assistant_check.platform.change_account_detail_template.confirm_modal.explanation'
)

const btnCancelLabel = window.I18n.t('common.cancel')

const btnConfirmLabel = window.I18n.t(
  'assistant_check.platform.change_account_detail_template.action'
)

const openModal = ({
  onConfirm: confirmCallback,
  action: action,
}: {
  onConfirm: () => void
  action: CheckAction
}): void => {
  showModal.value = true
  const actionExtraParams =
    action.parameters as ChangeAccountDetailTemplateParameters

  onConfirm = confirmCallback
  currentTemplateName.value = actionExtraParams.currentTemplateName
  suggestedTemplateName.value = actionExtraParams.suggestedTemplateName
  partnerTemplateDescription.value =
    actionExtraParams.partnerTemplateDescription
  actionHeapAnalyticId.value = `assistant-action-execute-${action.actionType.replace(
    /_/g,
    '-'
  )}`
}

const closeModal = (): void => {
  showModal.value = false
}

const confirm = (): void => {
  onConfirm()
  closeModal()
}

defineExpose({
  openModal,
})
</script>
